import request from '@/plugin/axios';
import util from '@/libs/util'

const apiUrl = process.env.VUE_APP_API;
const webSite = process.env.VUE_APP_SITE;

// 去授权登录
export function toOauth(redirect) {
    const url = apiUrl +
        'oauth/to_oauth/anon?callBackUrl=' +
        encodeURIComponent(webSite +  'redirect?routerUrl=' + redirect) +
        '&loginType=102'
    window.location.href = url
}

// 根据openId和登录类型免密登录
export function passwordFreeLogin(data) {
    return request({
        url: apiUrl + 'system_user/login_for_free_password_by_open_id_and_login_type/anon',
        method: 'POST',
        data
    });
}
